import React from "react";
import Sketch from "react-p5";
import { wall } from "./entities/wall";
import { door } from "./entities/door";
import { title } from "./entities/title";
import { window1 } from "./entities/window1";
import { window2 } from "./entities/window2";
import { frenchDoorL, frenchDoorR, frenchDoorC } from "./entities/frenchDoors";
import Timing from "./entities/Timing";
import styled from "styled-components";

const Container = styled.div`
  padding-top: ${({ h }) => 576 - h}px;
  position: relative;
  transform: scale(1.1);
`;

var width = 900;

export const WallPrintCanvas = ({ trait, yurtTrait }) => {
  const setup = (p5) => {
    var sketch = p5.createCanvas(width, trait.h + 100);
    sketch.parent(`wall-canvas-${trait.id}`);
  };

  const draw = (p5) => {
    p5.background(255);

    p5.resizeCanvas(width, yurtTrait.h + 150);
    if (trait.frenchDoor === "left") {
      frenchDoorL(p5, trait, width, yurtTrait);
    } else if (trait.frenchDoor === "center") {
      frenchDoorC(p5, trait, width, yurtTrait);
    } else if (trait.frenchDoor === "right") {
      frenchDoorR(p5, trait, width, yurtTrait);
    } else {
      wall(p5, trait, width, yurtTrait);
    }

    if (trait.doors) {
      door(p5, trait, width, yurtTrait);
    }

    if (trait.windows === 1) {
      window1(p5, trait, width, yurtTrait);
    } else if (trait.windows === 2) {
      window1(p5, trait, width, yurtTrait);
      window2(p5, trait, width, yurtTrait);
    }

    title(p5, trait, width, yurtTrait);
  };
  console.log(yurtTrait.h);
  return (
    <Container
      id={`wall-canvas-${trait.id}`}
      className="all-drawings"
      h={yurtTrait.h - 576}
    >
      <Sketch setup={setup} draw={draw} />
      <Timing trait={trait} allPrint={true} />
    </Container>
  );
};

export default WallPrintCanvas;
